import AbstractElement from "./AbstractElement";
import SectionTab from "../components/tab/SectionTab";
import Product from "../components/product/Product";
import MosaicEffect from "../components/MosaicEffect";
import CSSTransitionInElement from "../components/CSSTransitionInElement";
import TabProduct from "../components/product/TabProduct";
import AudioTabProduct from "../components/product/AudioTabProduct";


class ConnectivityElement extends AbstractElement {
    constructor(template: JQuery) {
        super(template);
    }

    update(scrollTop?: number): void {
        if (this.banner) this.banner.update(scrollTop, window.innerHeight / 3);
        if (this.title) this.title.update(scrollTop, window.innerHeight / 3);
        if (this.desc) this.desc.update(scrollTop, window.innerHeight / 3);
        if (this.divider) this.divider.update(scrollTop, window.innerHeight / 2);
        if (this.mosaic) this.mosaic.update(scrollTop, window.innerHeight / 3);
    }

    private banner: CSSTransitionInElement;
    private title: CSSTransitionInElement;
    private desc: CSSTransitionInElement;
    private divider: CSSTransitionInElement;
    private mosaic: MosaicEffect;

    init(): void {
        const $intro = this.template.find('.section__intro');
        this.banner = new CSSTransitionInElement($intro.find('.section__banner'));
        this.title = new CSSTransitionInElement($intro.find('.section__info__title'));
        this.desc = new CSSTransitionInElement($intro.find('.section__info__desc'));
        this.divider = new CSSTransitionInElement(this.template.find('.tab__divider'));
        this.mosaic = new MosaicEffect(this.template.find('.mosaic'));
        this.initTabs();
    }

    private initTabs(): void {

        const tabConnectivity = new SectionTab(this.template.find('#tabConnectivity'));
        tabConnectivity.changeBgColor('#0f0f0f');

        const productAudio = new AudioTabProduct(this.template.find('#productAudio'));
        productAudio.emitter.on('CAROUSEL_REFRESHED', () => {
            tabConnectivity.changeContentHeight();
        });
    }
}

export default ConnectivityElement;